import { usePrismItemStore } from 'stores/usePrismItemStore';

class PrismItemInterrogator {
  getCurrentSection = () => {
    const prismItem = usePrismItemStore.getState().prismItem;
    if (!window.activeView || !prismItem || !prismItem.pages || !prismItem.pages[activeView.pageIndex]) {
      return null;
    }

    // removing assignment to 0 for envelopes to not show any designs as it is not real section
    return prismItem.pages[activeView.pageIndex].product_section;
  }
}

const prismItemInterrogator = new PrismItemInterrogator();
export default prismItemInterrogator;
